import { borderRadius } from '@toggle/design-system';
import styled from 'styled-components';

export const BottomSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  margin-left: 4px;

  & > svg {
    fill: var(--text-soft);
  }
`;

export const MenuWrapper = styled.div`
  padding: 0px;
  border: unset;
  ${borderRadius.r2}
  width: 240px;
  background-color: var(--background-default);
`;
